/**
 * Entity ownership types - defines what types of entities can own resources
 *
 * Used across multiple domains (wallets, signing accounts, etc.) to provide
 * consistent polymorphic ownership without foreign key constraints.
 */
export var AccountOwnerType;
(function (AccountOwnerType) {
    AccountOwnerType["USER"] = "user";
    AccountOwnerType["BUSINESS"] = "business";
    AccountOwnerType["TENANT"] = "tenant";
    AccountOwnerType["SYSTEM"] = "system";
    AccountOwnerType["EXTERNAL"] = "external"; // External non-system actors (e.g. third-party addresses)
})(AccountOwnerType || (AccountOwnerType = {}));
//# sourceMappingURL=owner-type.enum.js.map